import React, { useState, useEffect, useContext } from 'react';
import contractimg from '../assets/images/contract.png'
import { Container, Row, Col, Table } from "react-bootstrap";
import ReactMarkdown from 'react-markdown';
import { useNavigate,Link, useLocation  } from 'react-router-dom';
import { decryptString,encryptString  } from '../utils/commonFunctions';
import axios from 'axios';
import Loader from '../components/Loader';
import Navbar from './Navbar';
import html2pdf from 'html2pdf.js';
import { UserContext } from '../contexts/UserContext';
import FeedbackWidget from '../components/FeedbackWidget';
import About from '../components/About';
import { CONFIG} from '../config';



//const contract_demographics_web= {"contract_demographics_web":{"Market | Market Unit | Client Group":"EMEA | ASG | ASG PRD","Client Name":"BMW","Overall Delivery Lead":"bill.jewoh-nono","CQI":"<Not Available>","Dominant Service Group":"APPLICATION MANAGED SERVICES","Overall Summary":"The project involves development and operations for SAP applications and platforms in the product creation phase of BMW. The new scope delivery is ongoing and stable, with multiple contracts signed. However, there have been challenges with margin reduction, blocked topics, high attrition, and resource ramp down. The project end date has been postponed, and additional developers are still needed. The financial status is amber, and client satisfaction is good. There are no security issues, and the delivery is stable with some velocity concerns.","Overall Risk\/Issues":"Information Security: NA\nFinancial: Amber (Project not more in CQI), SAP EAC: 6,3% VS Actual CTD: 5,9%, Feb'25 CCI = 14,5% delivered versus 10,0% planned\nClient Satisfaction: NA\nDelivery: PMD: Velocity too low, Spillover not finished in January, Senior and appropriate skills not easy to find, Delivery in the other sub product status green\nPeople\/Resources: Still searching for 1 Mainframe, 2 ABAP, & 1 BW Developer, High team attrition in HWA & GBE, Appropriate skills not easy to find\nContract Management: No issue","Overall Risk\/Issues1":"**Financial**:\n - Amber (Project not more in CQI), SAP EAC: 6,3% VS Actual CTD: 5,9%, Feb'25 CCI = 14,5% delivered versus 10,0% planned\n\n**Delivery**:\n - PMD: Velocity too low, Spillover not finished in January, Senior and appropriate skills not easy to find, Delivery in the other sub product status green\n\n**People\/Resources**:\n - Still searching for 1 Mainframe, 2 ABAP, & 1 BW Developer, High team attrition in HWA & GBE, Appropriate skills not easy to find\n\n**Contract Management**:\n - No issue","tmsList":[{"TMS ID | Team Name":"347592 | 38430 - DevOps_EBOM","Market | Market Unit | CSG":"EMEA | PRDLSI | Auto & Mobility","Overall Status":"Good$Green","Information Security Status":"Good$Green","Financial Status":"Good$Green","Client Satisfaction Status":"Good$Green","Delivery Status":"Good$Green","People\/Resources Status":"Good$Green","Contract Management Status":"Good$Green"}]},"summary":""}
//const contract_demographics=contract_demographics_web.contract_demographics_web.tmsList;

const columns = ["TMS ID | Team Name","Market | MU or IG | Industry","Overall","Client Satisfaction","Delivery","Financial","People / Resources","Information Security","Contract Management"];
const genAIcolumns = ["TMS ID | Team Name", "Market | MU or IG | Industry","Committed vs Scaled","Gen AI RAG Status - Committed","Patterns","Committed Gen AI Effort Savings","Savings Reflection","Scaled GenAI Savings %",,"Planned GenAI Productivity ($)","Realized GenAI Productivity ($)"];

function displayStatusColor(value){
  let parts = value.split('$');
  var status='';
  switch (parts[1]) {
    case "Green":
      status='green-circle';
      break;
    case "Amber":
      status='orange-circle';
      break;
    case 'Red':
      status='red-circle';
      break;
    case 'Grey':
      status='grey-circle';
      break;
    default:
      status='grey-circle';
  }
  return status
}

const Contract = () => {
     const apiUrl = CONFIG.REACT_APP_BACKEND_URL+'/classifier_retrieval';
    //const apiUrl='https://divadevfalcon.azurewebsites.net/classifier_retrieval';   
    const location = useLocation();
    const fullPath = location.pathname; 
    const encryptedId = fullPath.replace("/contact/", "");
    const [filterColumn, setFilterColumn] = useState(null);
    const [genAIFilterColumn, setGenAIFilterColumn] = useState(null);        
    const [modalOpen, setModalOpen] = useState(false);
    const [genAIModalOpen, setGenAIModalOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [genAISearchText, setGenAISearchText] = useState("");
    const [selectedOptions, setSelectedOptions] = useState({});
    const [selectedGenAIOptions, setSelectedGenAIOptions] = useState({});
    const [allSelected, setAllSelected] = useState(false);
    const [genAIAllSelected, setGenAIAllSelected] = useState(false);
    const [error, setError] = useState("");
    const [userId, setUserId] = useState("");
    const [e2eName, sete2eName] = useState("");
    const [contractId, setContractId] = useState("");
    const [clientNameUrl, setClientNameUrl] = useState("");
    const [clientName, setClientName] = useState("");
    const [loading, setLoading] = useState(true);           
    const [filteredData, setFilteredData] = useState([]);
    const [genAIFilteredData, setGenAIFilteredData] = useState([]);
    const [contractDemographicsWeb, setContractDemographicsWeb] = useState([]);
    const [displayCol, setdisplayCol] = useState(["TMS ID | Team Name","Market | MU or IG | Industry"]);
    const [genAIDisplayCol, setGenAIDisplayCol] = useState(["TMS ID | Team Name", "Market | MU or IG | Industry","Committed vs Scaled","Gen AI RAG Status - Committed","Patterns","Committed Gen AI Effort Savings","Savings Reflection","Scaled GenAI Savings %","Planned GenAI Productivity ($)","Realized GenAI Productivity ($)"]);
    const [sortColumn, setSortColumn] = useState(''); // name or status
    const [genAISortColumn, setGenAISortColumn] = useState(''); 
    const colorPriority = { "red-circle": 1, "orange-circle": 2, "green-circle": 3, "gray-circle": 4 };
    const navigate = useNavigate();
    const { contractsContext, setContractsContext } = useContext(UserContext);
    const [showFeedback, setShowFeedback] = useState(true);
    const [showkeyrisk, setkeyrisk] = useState(true);
    const [genAIExpanded, setGenAIExpanded] = useState({
        committedTab: false,
        scaledTab: false,
      });
    const [hasCommittedData,setHasCommittedData]=  useState(true);

    
 
    useEffect(() => {
      if(encryptedId){
        fetchData(encryptedId);
      }
      const handleClickOutside = (e) => {
        if (!e.target.closest(".filter-popup") && !e.target.closest(".filter-icon")) {
          setModalOpen(false);
          setGenAIModalOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

const ragMap = {
  Green: "🟢",
  Red: "🔴",
  Amber: "🟡",
  Grey: "🔘"
};

const getRagIcon = (value) => {
  try {
    // Handle null, undefined, "", NaN, objects, numbers
    if (!value || typeof value !== "string") return "NA";

    // Clean input
    const cleanValue = value.trim().toLowerCase();

    // Find key by case-insensitive match
    for (const key in ragMap) {
      if (key.toLowerCase() === cleanValue) {
        return ragMap[key];
      }
    }

    return "NA"; // default
  } catch (e) {
    return "NA";
  }
};

function displayRagColour(value) {
  if (!value || value.toString().trim() === "") {
    return "NA";
  }

  const ragMap = {
    "Green": "🟢",
    "Red": "🔴",
    "Amber": "🟡",
    "Grey": "🔘"
  };

  const items = value.split(",");
  let resultLines = [];
  let currentRag = null;

  // -------- First Pass: detect first rag label --------
  for (let item of items) {
    if (item.includes(":")) {
      const [, rag] = item.split(":");
      currentRag = rag.trim();
      break;
    }
  }

  // Default if no rag found
  if (!currentRag) currentRag = "Grey";

  // -------- Second Pass: assign or update rag --------
  for (let item of items) {
    let label;

    if (item.includes(":")) {
      const parts = item.split(":");
      label = parts[0].trim();
      currentRag = parts[1].trim(); // update rag only if explicitly present
    } else {
      label = item.trim();
    }

    const emoji = ragMap[currentRag] || "🔘";
    resultLines.push(` ${emoji} ${label}`);
  }

  return resultLines.join("\n");
}

const getgiFilteredData= (contract_demographics_web) =>{
        let copyJson = JSON.parse(JSON.stringify(contract_demographics_web.tmsList));
      var finalJson=[];
      copyJson.forEach(item => {
        finalJson = copyJson.filter(o => o['Committed vs Scaled']?.toString().trim() || o['Realized GenAI Productivity ($)']?.toString().trim() || o['Planned GenAI Productivity ($)']?.toString().trim()|| o['Planned GenAI Productivity ($)']?.toString().trim());
      });
      return finalJson;  
}

const hasValue = (val) =>
  val !== null &&
  val !== undefined &&
  val !== "";



    const fetchData = async (id) => {
      try{
      const postData=decryptString(decodeURIComponent(id));
      console.log('postData json',postData);
      postData.query='contract_demographics';
      postData.query_type='contract_demographics_web';
      postData.startdate='';
      postData.enddate='';
      postData.tmsName='';
      postData.e2eId='';
      postData.tmsId='';
      postData.contractId='';
      postData.custom_search='False';
      if(postData.clientUrl && postData.clientUrl!='undefined' ){
      const clientData=decryptString(decodeURIComponent(postData.clientUrl));
      setClientNameUrl(encodeURIComponent(postData.clientUrl)); 
      if(clientData){
        setClientName(clientData.clientName);
      }
      console.log('clientData',clientData);
     }
      setkeyrisk(postData.showmore);
      console.log('postData.showmore',postData.showmore);
      setUserId(postData.enterprise_id);
         
      sete2eName(postData.e2eName);    
      setContractId(postData.contractId);       
      if(postData && postData.clientName && contractsContext && contractsContext[postData.contractID]) { 
        if (typeof contractsContext[postData.contractID] === "string") {
           contractsContext[postData.contractId] = contractsContext[postData.contractID].replace(/NaN/g, "null");
           contractsContext[postData.contractId]= JSON.parse(contractsContext[postData.contractID]);
        }      
        setContractDemographicsWeb(contractsContext[postData.contractID]);
        setHasCommittedData(hasValue(contractsContext[postData.contractID].contract_demographics_web?.['Committed | Scaled']));
        setFilteredData(contractsContext[postData.contractID].contract_demographics_web.tmsList); 
        var finalJson=getgiFilteredData(contractsContext[postData.contractID].contract_demographics_web);
        setGenAIFilteredData(finalJson);         
      } else { 
       // var response={data:{"contract_demographics_web": {"focusjob_context": [{"id": 22624, "contract_id": "9940475673", "reason_for_focus": "NaN", "status": "NaN", "market_new": "NaN", "market_unit_new": "NaN", "focus_job": "NaN", "rde_portfolio_delivery_lead_comments": "Reason for Call-out : Overall Status : At Risk, Financial DL Reported RAG is AMBER and Financial Data driven RAG is RED, SI   Fixed Price with GenAI commitment, CQI = MU Review, -ve EAC forecastTrigger Type : Delivery, Financial, Quality", "portfolio_lead_comments_quality_comments": "2.27.2024 SDR: prep-call feedback No need to review02/12/2024 SDR: Q&R for criteria for review. Not tagged for joint review.", "atc_ioc_comments": "NaN", "gov_reason_for_callout_del_ops": "Reason for contract getting tagged as Problem Job (PJ)OverallDL Reported RAG - AmberMarking overall status as Amber as Financials are Amber.FinancialsDL Reported RAG - AmberData Driven RAG - Red•Best, Likely   Worst case scenarios showcased during CQI review. Claw back plan created for the CCI gap (~$3.5 Mn) for Likely scenario. •~$250K positive revenue true up realized for the July-Sept 24 Qtr. -$3K true up for the Oct-Dec 24 Qtr.•Landing CCI for current fiscal year improved from 3.7% to 7% as a result of the financials clawback initiatives.", "pj_ppj_eri": "PJ", "pjppj_tagging": "Yes", "filename": "Contracts Tagged For Review_27th Oct 2025.xlsx"}], "Focusjob_PJPPJ_Tagging": {"Tagging": "PJ", "Reason for Review Tagging": "- Financial: negative EAC forecast, claw back plan created for the CCI gap (~$3.5 Mn), financials are Amber, financial data driven RAG is RED.  \n- Delivery: overall status marked as At Risk, CQI review indicates delivery issues.  \n- Quality: financials clawback initiatives improved quality metrics from 3.7% to 7%.  \n- Contract management: contract flagged as Problem Job (PJ).  "}, "last_sunday": "30-Nov-2025", "Market | Market Unit | Client Group": "Americas | US-Products | US-CG&S, Retail, Travel", "Client Name": "BUNGE", "Overall Delivery Lead": "chanchu.raman", "CQI": "MU Review", "Dominant Service Group": "APPLICATION MANAGED SERVICES", "Overall Summary": "The project status is Amber due to financial underruns and ongoing client escalations. Client satisfaction has improved to Green, with high ticket resolution rates. Staffing challenges are mostly resolved. Key actions are in progress for various initiatives, including portal migration and SAP upgrades, with some pending approvals.", "Overall Risk/Issues": "- **Information Security**: Dependency on Bunge continues to be a challenge in GTM/Risk areas due to additional complexity. An incident is in progress with the Security team for Production (PR1) system access.\n\n- **Financial**: Projected $8M underrun based on current AMS staffing and actuals. Multiple clawbacks totaling $3.3M due to staffing reductions, leadership transitions, SLA penalty removal, and PTO forecast updates. There is an ongoing effort to process EAC for the actual gap in CCI (~$2.2M).\n\n- **Client Satisfaction**: While overall feedback has improved in certain areas, the dependency on Bunge remains a challenge, indicating potential dissatisfaction in GTM/Risk areas.\n\n- **Delivery**: There are 15 Change Requests (CRs) pending CMC approval. The SAP Upgrade project resulted in additional tickets and an uptick in aging due to the September release.\n\n- **People/Resources**: NA\n\n- **Contract Management**: NA", "Overall Risk/Issues1": "**Information Security**:\n - Dependency on Bunge continues to be a challenge in GTM/Risk areas due to additional complexity.\n - An incident is in progress with the Security team for Production (PR1) system access.\n\n**Financial**:\n - Projected $8M underrun based on current AMS staffing and actuals.\n - Multiple clawbacks totaling $3.3M due to staffing reductions, leadership transitions, SLA penalty removal, and PTO forecast updates.\n - There is an ongoing effort to process EAC for the actual gap in CCI (~$2.2M).\n\n**Client Satisfaction**:\n - The dependency on Bunge remains a challenge, indicating potential dissatisfaction in GTM/Risk areas.\n\n**Delivery**:\n - There are 15 Change Requests (CRs) pending CMC approval.\n - The SAP Upgrade project resulted in additional tickets and an uptick in aging due to the September release.", "Overall Risk/Issues from narratives": "**Information Security**:\n - Dependency on Bunge continues to be a challenge in GTM/Risk areas due to additional complexity.\n - An incident is in progress with the Security team for Production (PR1) system access.\n\n**Financial**:\n - Projected $8M underrun based on current AMS staffing and actuals.\n - Multiple clawbacks totaling $3.3M due to staffing reductions, leadership transitions, SLA penalty removal, and PTO forecast updates.\n - There is an ongoing effort to process EAC for the actual gap in CCI (~$2.2M).\n\n**Client Satisfaction**:\n - The dependency on Bunge remains a challenge, indicating potential dissatisfaction in GTM/Risk areas.\n\n**Delivery**:\n - There are 15 Change Requests (CRs) pending CMC approval.\n - The SAP Upgrade project resulted in additional tickets and an uptick in aging due to the September release.", "tmsList": [{"TMS ID | Team Name": "456376 | 46819 - Bunge_ATCI_AMS_AD", "Market | Market Unit | CSG": "Americas | PRDCRT | Con Goods & Services", "Overall Status": "At Risk$Amber", "Alert/At Risk Columns": {"financialStatus": "At Risk$Amber"}, "narratives summary": "The project status is Amber due to financial underruns and ongoing client escalations. Client satisfaction has improved to Green, with most staffing challenges resolved. Key actions are in progress for incident resolution, portal migration, and backlog reduction, while financial clawbacks are being addressed.", "Risk/Issues": "Information Security: NA  \nFinancial: $8M underrun projected based on current AMS staffing and actuals; multiple clawbacks totaling $3.3M due to staffing reductions, leadership transitions, and SLA penalty removals; ongoing discussions with CFM team regarding a $2.2M gap in CCI.  \nClient Satisfaction: Dependency on Bunge continues to be a challenge in GTM/Risk areas due to additional complexity.  \nDelivery: Noise around GTM/Risk has reduced, but challenges persist; 15 CRs pending CMC approval; incident in progress with the Security team for Production system access.  \nPeople/Resources: NA  \nContract Management: NA  ", "Risk/Issues1": "**Financial**:\n - $8M underrun projected based on current AMS staffing and actuals; multiple clawbacks totaling $3.3M due to staffing reductions, leadership transitions, and SLA penalty removals; ongoing discussions with CFM team regarding a $2.2M gap in CCI.\n\n**Client Satisfaction**:\n - Dependency on Bunge continues to be a challenge in GTM/Risk areas due to additional complexity.\n\n**Delivery**:\n - Noise around GTM/Risk has reduced, but challenges persist; 15 CRs pending CMC approval; incident in progress with the Security team for Production system access.", "tmsName": "46819 - Bunge_ATCI_AMS_AD", "scaled": [{"genaiappliedservicegroup": "AMS-AM - ", "genairealizedproductivity": "None", "genaiproductivity": "None", "genaiSavings": "0.0", "whereIsTheSavingsBeingReflected": "Meeting Solutioned GenAI Targets/Commitments"}], "committed": [{"genaiappliedservicegroup": "AMS-AM", "pattern": "As per plan (For both date / committed value)", "ragStatus": "Green", "effortsavingsgenaiplannedperc": "7"}, {"genaiappliedservicegroup": "SI", "pattern": "Client not finalized on tool", "ragStatus": "Amber", "effortsavingsgenaiplannedperc": "87"}]}, {"TMS ID | Team Name": "480233 | 49325 - Bunge SAP Basis & Security CPM", "Market | Market Unit | CSG": "Infrastructure-Engineering | Infra-Trnf_Cloud-Migr | PRD", "Overall Status": "Good$Green", "Alert/At Risk Columns": {}, "narratives summary": "The project has closed 46 production and 128 non-prod tasks, resolving 47 incidents and 99 events. Financials are amber, with a clawback plan in place. Client concerns on support quality persist. Security incidents are being managed, and resource optimization is ongoing. Contract signed; no SOX issues reported.", "Risk/Issues": "Information Security: NA  \nFinancial: Financials in amber for overall project (as per data driven it is red). Claw back plan created for the CCI gap (~$3.5 Mn) for Likely scenario.  \nClient Satisfaction: Client EMEA SOX team has raised concerns on the quality of support. Repetitive mistakes were happening from the juniors.  \nDelivery: Delivery was downgraded to Amber week of 11/23. Major Incident - P2 – INC4008185 – Waiting for user confirmation.  \nPeople/Resources: Skill gap in team, repetitive mistakes, ageing issues reported by the client.  \nContract Management: NA  ", "Risk/Issues1": "**Financial**:\n - Financials in amber for overall project (as per data driven it is red).\n - Claw back plan created for the CCI gap (~$3.5 Mn) for Likely scenario.\n\n**Client Satisfaction**:\n - Client EMEA SOX team has raised concerns on the quality of support.\n - Repetitive mistakes were happening from the juniors.\n\n**Delivery**:\n - Delivery was downgraded to Amber week of 11/23.\n - Major Incident - P2 – INC4008185 – Waiting for user confirmation.\n\n**People/Resources**:\n - Skill gap in team, repetitive mistakes, ageing issues reported by the client.", "tmsName": "49325 - Bunge SAP Basis & Security CPM", "scaled": "nan", "committed": "nan"}, {"TMS ID | Team Name": "492560 | 50456 - BUNGE SFDC AO", "Market | Market Unit | CSG": "Americas | EP | Con Goods & Services", "Overall Status": "Good$Green", "Alert/At Risk Columns": {}, "narratives summary": "The project is on track with no escalations, supporting 9 applications and resolving 432 incidents and 359 enhancements. Financials are monitored, and all information security controls are green. The contract is valued at $3.73M, with 10 FTEs allocated across India and Brazil.", "Risk/Issues": "Information Security: NA  \nFinancial: NA  \nClient Satisfaction: NA  \nDelivery: There is a potential risk regarding the SLA, as it is stated that there is no SLA applicable till the end of baseline period.This could lead to issues in service expectations and accountability until January 16, 2025.  \nPeople/Resources: NA  \nContract Management: NA  ", "Risk/Issues1": "**Delivery**:\n - There is a potential risk regarding the SLA, as it is stated that there is no SLA applicable till the end of baseline period.This could lead to issues in service expectations and accountability until January 16, 2025.", "tmsName": "50456 - BUNGE SFDC AO", "scaled": "nan", "committed": "nan"}]}, "summary": ""}}    
       await axios.post(apiUrl, postData)
       .then(response => {
        console.log('response',response);
         if (typeof response.data === "string") {
           response.data = response.data.replace(/NaN/g, "null");
           response.data= JSON.parse(response.data);
        }
        setContractDemographicsWeb(response.data);      
        //sete2eName(postData.clientUrl);      
        //setContractId(postData.clientUrl); 
       
        response.data.contract_demographics_web.tmsList.forEach(item => {
          for (let key in item) {
            if(key==="Overall Status"){
              item.Overall=displayStatusColor(item["Overall Status"]);
            } else if(key==="Delivery Status"){
              item.Delivery=displayStatusColor(item["Delivery Status"]);
            } else if(key==="Financial Status"){
              item.Financial=displayStatusColor(item["Financial Status"]);
            } else if(key==="People/Resources Status"){
              item['People / Resources']=displayStatusColor(item["People/Resources Status"]);
            } else if(key==="Information Security Status"){
              item['Information Security']=displayStatusColor(item["Information Security Status"]);
            } else if(key==="Contract Management Status"){
              item['Contract Management']=displayStatusColor(item["Contract Management Status"]);
            } else if(key==="Client Satisfaction Status"){
              item['Client Satisfaction']=displayStatusColor(item["Client Satisfaction Status"]);
            } else if(key==="Market | Market Unit | CSG"){
              item['Market | MU or IG | Industry']=item["Market | Market Unit | CSG"];
            }  else if(key==="Planned Gen AI Productivity ($)"){
               item['Planned GenAI Productivity ($)']=item["Planned Gen AI Productivity ($)"];        
            } else if(key==="Realized Gen AI Productivity ($)"){
               item['Realized GenAI Productivity ($)']=item["Realized Gen AI Productivity ($)"];        
            } else if(key==='Committed | Scaled '){
               item['Committed vs Scaled']=item["Committed | Scaled "];
            } else if(key==='Patterns'){
               item['Patterns']=item["Patterns"];
            } else if(key==='committed-RAG'){
               item['Gen AI RAG Status - Committed']=displayRagColour(item["committed-RAG"]);
            } else if(key==='GenAI Savings %'){
               item['Scaled GenAI Savings %']=displayRagColour(item["GenAI Savings %"]);
            } else if(key==='Committed Gen AI Effort Savings %'){
               item['Committed Gen AI Effort Savings']=displayRagColour(item["Committed Gen AI Effort Savings %"]);
            } 
 
          }
        });
        console.log('response',response)
        
        setHasCommittedData(hasValue(response?.data?.contract_demographics_web?.['Committed | Scaled']));
        setFilteredData(response.data.contract_demographics_web.tmsList);
        var finalJson=getgiFilteredData(response.data.contract_demographics_web);
        setGenAIFilteredData(finalJson);        
        setContractsContext(prev => ({
          ...prev,
          [postData.contractID]: response.data
        }));

      })
      .catch(error => {
        console.error('Error posting data:', error);
        setError("Failed to fetch data.");
      });  
    }   
      
    } catch (err) {
      setError("Failed to fetch data.");
    } finally {
      setLoading(false);
    } 
    }
    const handleGenAiSort = (column) => {
      setGenAISortColumn(column);
  
      const sortedData = [...genAIFilteredData].sort((a, b) => {
        if (genAIDisplayCol.includes(column)) {
          return a[column].localeCompare(b[column], undefined, { numeric: true, sensitivity: "base" });
        } else {
          return (colorPriority[a[column]] || 99) - (colorPriority[b[column]] || 99); // custom color sort
        }
      });
  
      console.log('sortedData',sortedData);
      setGenAIFilteredData(sortedData);
    };
    
     const handleGenAIFilterClick = (column) => {
      setGenAIFilterColumn(column);
      setGenAISearchText("");
      setGenAIModalOpen(true);
    };
  
    const handleGenAICheckboxChange = (value) => {
      setSelectedGenAIOptions((prev) => ({
        ...prev,
        [value]: !prev[value],
      }));
    };
  
    const handleGenAISelectAll = () => {
      const options = getGenAIUniqueOptions();
      const newSelected = {};
      if (!genAIAllSelected) {
        options.forEach((option) => {
          newSelected[option] = true;
        });
      }
      setSelectedGenAIOptions(newSelected);
      setGenAIAllSelected(!genAIAllSelected);
    };
  
    const displayGenAIColumnsData = (col,value) =>{
      if(genAIDisplayCol.includes(col))
        return value;
      else return '';
    }

    const handleGenAIRowClick=() =>{
      console.log('inside');
    } 
    
    
    const handleSort = (column) => {
      setSortColumn(column);
  
      const sortedData = [...filteredData].sort((a, b) => {
        if (displayCol.includes(column)) {
          return a[column].localeCompare(b[column], undefined, { numeric: true, sensitivity: "base" });
        } else {
          return (colorPriority[a[column]] || 99) - (colorPriority[b[column]] || 99); // custom color sort
        }
      });
  
      console.log('sortedData',sortedData);
      setFilteredData(sortedData);
    };
  
    const handleFilterClick = (column) => {
      setFilterColumn(column);
      setSearchText("");
      setModalOpen(true);
    };
  
    const handleCheckboxChange = (value) => {
      setSelectedOptions((prev) => ({
        ...prev,
        [value]: !prev[value],
      }));
    };
  
    const handleSelectAll = () => {
      const options = getUniqueOptions();
      const newSelected = {};
      if (!allSelected) {
        options.forEach((option) => {
          newSelected[option] = true;
        });
      }
      setSelectedOptions(newSelected);
      setAllSelected(!allSelected);
    };
  
    const displayColumnsData = (col,value) =>{
      if(displayCol.includes(col))
        return value;
      else return '';
    }
    const handleRowClick = (contact) => {
      console.log('contact',contact);
      // Navigate to another page
      const reqObj={};
      reqObj.tmsName=(contact['TMS ID | Team Name'].split("|")[1]).trim();
      reqObj.enterprise_id=userId;
      reqObj.clientUrl=decodeURIComponent(clientNameUrl);
      reqObj.contractUrl=encryptedId;
      const contractEncryptString=encryptString(reqObj);
      console.log('contractEncryptString',contractEncryptString);
      
      navigate(`/project/${contractEncryptString}`);
    };
  
    const handleApply = () => {
      if (!filterColumn) return;
  
      const selectedValues = Object.keys(selectedOptions).filter((key) => selectedOptions[key]);
  
      if (selectedValues.length === 0) {
        setFilteredData(contractDemographicsWeb.contract_demographics_web.tmsList); // No filter, show all
      } else {
        const newFilteredData = contractDemographicsWeb.contract_demographics_web.tmsList.filter((row) =>
          selectedValues.includes(row[filterColumn]?.toString())
        );
        setFilteredData(newFilteredData); //  Update filtered data
      }
      setModalOpen(false);
    };

    const handleGenAIApply = () => {
      if (!genAIFilterColumn) return;
  
      const selectedValues = Object.keys(selectedGenAIOptions).filter((key) => selectedGenAIOptions[key]);
  
      if (selectedValues.length === 0) {
        let finalJson=getgiFilteredData(contractDemographicsWeb.contract_demographics_web);      
        setGenAIFilteredData(finalJson); // No filter, show all
      } else {
         let finalJson=getgiFilteredData(contractDemographicsWeb.contract_demographics_web);         
        const newFilteredData = finalJson.filter((row) =>
          selectedValues.includes(row[genAIFilterColumn]?.toString())
        );
        setGenAIFilteredData(newFilteredData); //  Update filtered data
      }
      setGenAIModalOpen(false);
    };

        const handlePdfDownload = async () => {
            setLoading(true);
            const container = document.createElement('div');
            const ids = ['clientHeader','image-container', 'about', 'contractLevelSummary','pills-contract_details-tab','pills-contract_details','pills-key_risks-tab', 'pills-key_risks','gen_ai_status-tab','gen_ai_status'];
            const originalStyles = [];
            ids.forEach(id => {
              const element = document.getElementById(id);
              if (element) {
                const tabpanel=['pills-contract_details','pills-key_risks','gen_ai_status'];               
                if(tabpanel.includes(id) && !element.classList.contains('active')){
                   originalStyles.push(element);
                //element.style.display = 'block';
                   element.classList.add('show','active');
                  //  const p = document.createElement('p');
                  //  p.textContent = 'This is a dynamic paragraph added after Section 1';
                  //  p.style.margin = '16px 0';
                  //  p.style.fontWeight = 'bold';
                  //  container.appendChild(p);
                }
                //originalStyles.push({ element, display: element.style.display });
                //element.style.display = 'block';
                const clone = element.cloneNode(true);
                clone.style.pageBreakInside = 'avoid';
               // clone.style.display = 'block';
        
                // 🧽 Remove elements by ID
                const toRemoveById = ['sortDiv','diva-userguide'];
                toRemoveById.forEach(rid => {
                  const el = clone.querySelector(`#${rid}`);
                  if (el) el.remove();
                });
    
                // const hiddenTabs = clone.querySelectorAll('.bi bi-filter');
                // hiddenTabs.forEach(tab => tab.classList.add('show', 'active'));
    
        
                // // 🧽 Remove elements by class
                 const toRemoveByClass = clone.querySelectorAll('.bi-filter');
                  toRemoveByClass.forEach(el => el.remove());
        
               // clone.style.marginBottom = '50px';
                container.appendChild(clone);
              }
            });
        
            // const options = {
            //   margin: 0.5,
            //   filename: 'filtered-sections.pdf',
            //   image: { type: 'jpeg', quality: 0.98 },
            //   html2canvas: { scale: 2 },
            //   jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            // }; 
            
            const newElement = document.createElement('div');
            newElement.style.marginTop = '20px';
            newElement.style.fontSize = '14px';
            newElement.style.fontWeight = 'bold';                 
            newElement.style.color = '#A100FF';                 
            newElement.style.textAlign = 'center';                 
            newElement.innerText = 'Content Generated by Gen AI, limiting accuracy in few cases. Please use at your own discretion.'; 
            container.appendChild(newElement);
            
            const options = {
              margin: 0.5,
              filename: e2eName+'.pdf',
              image: { type: 'jpeg', quality: 0.98 },
              html2canvas: {
                scale: 2,
                useCORS: true,
                allowTaint: true,
              },
              jsPDF: {
                unit: 'in',
                format: 'a3', // landscape format
                orientation: 'landscape'
              }
            };
            originalStyles.forEach(el  => {
              el.classList.remove('show','active');
            });
            html2pdf().set(options).from(container).save();
            setLoading(false);
          };
  
          const titleMap = {
            'green-circle': 'Good',
            'orange-circle': 'At Risk',
            'red-circle': 'Alert',
            'grey-circle': 'Not Reported',
          };      
    const getUniqueOptions = () => {
      if (!filterColumn) return [];
      const options = [...new Set(contractDemographicsWeb.contract_demographics_web.tmsList.map((item) => item[filterColumn]))];
      return options.filter((option) =>
        (option ?? "").toString().toLowerCase().includes(searchText.toLowerCase())
      );
    };

    const getGenAIUniqueOptions = () => {
      if (!genAIFilterColumn) return [];
      let finalJson=getgiFilteredData(contractDemographicsWeb.contract_demographics_web);      
      const options = [...new Set(finalJson.map((item) => item[genAIFilterColumn]))];
      return options.filter((option) =>
        (option ?? "").toString().toLowerCase().includes(genAISearchText.toLowerCase())
      );
    };
  // const expandAllGenAI = () => setGenAIExpanded({ committedTab: true, scaledTab: true });
  // const collapseAllGenAI = () => setGenAIExpanded({ committedTab: false, scaledTab: false });
  
  // const allExpanded = expandAllGenAI.committedTab && expandAllGenAI.scaledTab;
  // const allCollapsed = !expandAllGenAI.committedTab && !expandAllGenAI.scaledTab;

  //const contract_demographics_web= {"contract_demographics_web": {"Client Account Lead (CAL)": "roland.mayr", "Unified Account Lead (UAL)": "sharad.b.kumar.singh", "Global / Local TSL": "thi.long.thuan.tran / martin.felsch", "Diamond Client": "Yes", "Overall Risk/Issues": "**Information Security**: No specific risk/issues mentioned in the provided context.\n\n**Financial**: Amber status, wrong booking in Feb, impact on CCI, SAP EAC higher than Actual CTD, overall revenue from backlog underperformance, optimization in financial forecasting for sub-contractors, financial status amber, CY1 closed at 23%, FY25 planned landing at 23.3%, EAC gaps, budget consumption accuracy, high payroll cost and reduced revenue, increased costs due to team ramp up & KT, budget pressure from BMW, high front-loading in delivery, CTD costs higher compared to CTAIPB, ongoing discussions of maintenance offer.\n\n**Client Satisfaction**: No specific risk/issues mentioned in the provided context.\n\n**Delivery**: Velocity too low, spillover not finished in January, difficulty finding senior and appropriate skills, delivery in other sub-products is stable, quality of delivery needs improvement, defects due to coding error or design flaw, product ECMDelivery status yellow, ABT delivery still in stabilization, recent attrition impacting delivery timeline, historical knowledge lost, extensive ramp-up time, gAMS delivery with spill-overs, PLRSdelivery status is good, risk on dependency to Heirloom transpilation tool, ongoing negotiations with BMW impacting timeline, cost, and quality, performance issues with CCELM migration, safety development way behind plan, high risk of not delivering all safety-related topics, development of tests and testing way behind plan.\n\n**People/Resources**: Still searching for Mainframe, ABAP, and BW Developers, high team attrition, difficulty finding appropriate skills, three off-shore team members offboarded in February, staffing in progress for 1 mid/senior ABAP Dev, BMW budget challenges impacting resource utilization and planning to reduce team size, another IPB security developer resigned, a further low-level developer also resigned, most important low-level developer also resigned, high risk of not being able to deliver beginning of Q2/2025, no plan to compensate leave of APP1 key developer.\n\n**Contract Management**: No specific risk/issues mentioned in the provided context.\n\nSummary: Financial challenges, delivery issues, and people/resources constraints are impacting the contract. Client satisfaction and contract management do not have specific risk/issues mentioned.", "Overall Risk/Issues1": "**Financial**:\n - Amber status, wrong booking in Feb, impact on CCI, SAP EAC higher than Actual CTD, overall revenue from backlog underperformance, optimization in financial forecasting for sub-contractors, financial status amber, CY1 closed at 23%, FY25 planned landing at 23.3%, EAC gaps, budget consumption accuracy, high payroll cost and reduced revenue, increased costs due to team ramp up & KT, budget pressure from BMW, high front-loading in delivery, CTD costs higher compared to CTAIPB, ongoing discussions of maintenance offer.\n\n**Delivery**:\n - Velocity too low, spillover not finished in January, difficulty finding senior and appropriate skills, delivery in other sub-products is stable, quality of delivery needs improvement, defects due to coding error or design flaw, product ECMDelivery status yellow, ABT delivery still in stabilization, recent attrition impacting delivery timeline, historical knowledge lost, extensive ramp-up time, gAMS delivery with spill-overs, PLRSdelivery status is good, risk on dependency to Heirloom transpilation tool, ongoing negotiations with BMW impacting timeline, cost, and quality, performance issues with CCELM migration, safety development way behind plan, high risk of not delivering all safety-related topics, development of tests and testing way behind plan.\n\n**People/Resources**:\n - Still searching for Mainframe, ABAP, and BW Developers, high team attrition, difficulty finding appropriate skills, three off-shore team members offboarded in February, staffing in progress for 1 mid/senior ABAP Dev, BMW budget challenges impacting resource utilization and planning to reduce team size, another IPB security developer resigned, a further low-level developer also resigned, most important low-level developer also resigned, high risk of not being able to deliver beginning of Q2/2025, no plan to compensate leave of APP1 key developer.", "Overall Summary": "Contracts: DevOps ItO_008 EBOM, BMW CRM Retail - DOFC CRM FG140 OtODtCC11, DevOps ECM, Central Ordering, ESR_IP Basis have observed risks or issues. The risks or issues observed among these contracts are related to Financials, Delivery, People/Resources, and Contract Management.", "e2eList": [{"TMS ID | Team Name": "9940338503", "E2E ID | End To End Name": "304364 | DevOps ItO_008 EBOM", "Market | Market Unit | CSG": "EMEA | ASG | ASG PRD", "Overall Status": "At Risk$Amber", "Information Security Status": "Good$Green", "Financial Status": "At Risk$Amber", "Client Satisfaction Status": "Good$Green", "Delivery Status": "At Risk$Amber", "People/Resources Status": "At Risk$Amber", "Contract Management Status": "Good$Green"}, {"TMS ID | Team Name": "9940390148", "E2E ID | End To End Name": "372255 | BMW CRM Retail - DOFC CRM FG140 OtODtCC11", "Market | Market Unit | CSG": "EMEA | ASG | ASG PRD", "Overall Status": "At Risk$Amber", "Information Security Status": "Good$Green", "Financial Status": "At Risk$Amber", "Client Satisfaction Status": "Good$Green", "Delivery Status": "At Risk$Amber", "People/Resources Status": "At Risk$Amber", "Contract Management Status": "Good$Green"}, {"TMS ID | Team Name": "9940313756", "E2E ID | End To End Name": "261959 | DevOps ECM", "Market | Market Unit | CSG": "EMEA | ASG | ASG PRD", "Overall Status": "At Risk$Amber", "Information Security Status": "Good$Green", "Financial Status": "At Risk$Amber", "Client Satisfaction Status": "Good$Green", "Delivery Status": "At Risk$Amber", "People/Resources Status": "Good$Green", "Contract Management Status": "Not Reported$Grey"}, {"TMS ID | Team Name": "9940454817", "E2E ID | End To End Name": "436601 | Central Ordering", "Market | Market Unit | CSG": "EMEA | ASG | ASG PRD", "Overall Status": "At Risk$Amber", "Information Security Status": "Good$Green", "Financial Status": "At Risk$Amber", "Client Satisfaction Status": "Good$Green", "Delivery Status": "Good$Green", "People/Resources Status": "At Risk$Amber", "Contract Management Status": "Good$Green"}, {"TMS ID | Team Name": "9940406048", "E2E ID | End To End Name": "386612 | ESR_IP Basis", "Market | Market Unit | CSG": "EMEA | ASG | ASG PRD", "Overall Status": "Good$Green", "Information Security Status": "Good$Green", "Financial Status": "Alert$Red", "Client Satisfaction Status": "Good$Green", "Delivery Status": "At Risk$Amber", "People/Resources Status": "Alert$Red", "Contract Management Status": "Good$Green"}]}, "summary": ""};
  //const contract_demographics=contract_demographics_web.contract_demographics_web;
  if (error) { navigate(`/error`) }

  return (
    <div className="container">
      <Navbar />
      <div className='image-container container' id="image-container">
      <img src={contractimg}  alt="diva" className="client-img" />  
      <div className='text-overlay'>{e2eName}</div>
      <div className='text-overlay text-contractID'>{contractId}</div>
      </div>
      <Container className="mt-4 totalClient">
      {/* Top Section with About & Export Button */}
      <Row className="align-items-center mb-3">
        <Col md={6} id="about">
          <h3>About</h3>
        </Col>
        <Col md={6} className="text-end"> 
        <div class="btn-group export-btn" role="group">
          <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            Export
          </button>
          <ul class="dropdown-menu">
            {/* <li><a class="dropdown-item" href="#" >PDF</a></li> */}
            <li><a class="dropdown-item" href="#" onClick={handlePdfDownload}>PDF</a></li>
          </ul>
        </div>
        </Col>
      </Row>
      <div className='d-flex justify-content-between'>
      <div className='p-2'>
      {(clientNameUrl && clientNameUrl !== "undefined") && <nav aria-label="breadcrumb"> 
              <ol className="breadcrumb">
        <li className="breadcrumb-item">
          <Link className="breadcrumblink" to={`/client/${clientNameUrl}`}>{clientName}</Link>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          {e2eName}
        </li>
      </ol>
    </nav> }
    </div>
    <div className='p-2'>
      <span>Data Source: MMD as on </span><span className='totalscr'>{contractDemographicsWeb?.contract_demographics_web?.last_sunday}</span>
    </div>
    </div>
      {/* Gray Background Box */}
      <div className="p-3 bg-light rounded" id="contractLevelSummary">
        <h5 className='summaryTypeHeading'>Contract level summary</h5>
        <table >
  <tbody class="container mt-4">
    <tr>
      <td className="col-6 col-md-4 width18 text-start">Market | MU or IG | Industry:</td>
      <td class="col-6 col-md-4 text-start">{contractDemographicsWeb && contractDemographicsWeb.contract_demographics_web && contractDemographicsWeb.contract_demographics_web['Market | Market Unit | Client Group']? contractDemographicsWeb.contract_demographics_web['Market | Market Unit | Client Group']:''}</td>
      <td class="col-6 col-md-4 text-start">Overall Delivery Lead|ATCI Contract Lead(ACL):</td>
      <td class="col-6 col-md-4 text-start">{contractDemographicsWeb && contractDemographicsWeb.contract_demographics_web && contractDemographicsWeb.contract_demographics_web['Overall Delivery Lead']? contractDemographicsWeb.contract_demographics_web['Overall Delivery Lead'] : ''} {  contractDemographicsWeb && contractDemographicsWeb.contract_demographics_web && contractDemographicsWeb.contract_demographics_web['atciContractLead']? ' | ' +contractDemographicsWeb.contract_demographics_web['atciContractLead'] : '--'}</td>
    </tr>
    <tr>
      <td className="col-6 col-md-4 width18 text-start">Client Name:</td>
      <td className="col-6 col-md-4 text-start">{contractDemographicsWeb && contractDemographicsWeb.contract_demographics_web && contractDemographicsWeb.contract_demographics_web['Client Name']? contractDemographicsWeb.contract_demographics_web['Client Name'] :''}</td>
      <td className="col-6 col-md-4 text-start">CQI:</td>
      <td className="col-6 col-md-4 text-start">{contractDemographicsWeb && contractDemographicsWeb.contract_demographics_web && contractDemographicsWeb.contract_demographics_web['CQI']? contractDemographicsWeb.contract_demographics_web['CQI'] :''}</td>
    </tr>
    <tr>
      <td className="col-6 col-md-4 width18 text-start">Review Tag:</td>
      <td className="col-6 col-md-4 text-start">{contractDemographicsWeb.contract_demographics_web?.['Focusjob_PJPPJ_Tagging']?.['Tagging'] ?? 'None'}</td>
      <td className="col-6 col-md-4 text-start">Profit Max Plan (PMP) Status</td>
      <td className="col-6 col-md-4 text-start">{contractDemographicsWeb.contract_demographics_web?.['Focusjob_PJPPJ_Tagging']?.['plan_status'] ?? 'None'}</td>
    </tr>
  </tbody>
</table>

      </div>

      <ul class="nav nav-pills mb-3 displayTab" id="pills-tab" role="tablist">
      <li class="nav-item" role="presentation">
        <button className={`nav-link  ${showkeyrisk!=false ? 'active' : ''}`} id="pills-contract_details-tab" data-bs-toggle="pill" data-bs-target="#pills-contract_details" type="button" role="tab" aria-controls="pills-contract_details" aria-selected="true" >Project Details</button>
      </li>
      <li class="nav-item" role="presentation">
          <button className={`nav-link  ${showkeyrisk==false ? 'active' : ''}`} id="pills-key_risks-tab" data-bs-toggle="pill" data-bs-target="#pills-key_risks" type="button" role="tab" aria-controls="pills-key_risks" aria-selected="false" >Key Risks</button>
      </li>
      { hasCommittedData && ( <li className="nav-item" role="presentation">
        <button className="nav-link" id="gen_ai_status-tab" data-bs-toggle="pill" data-bs-target="#gen_ai_status" type="button" role="tab" aria-controls="gen_ai_status" aria-selected="false">Gen AI Status</button>
      </li>) }
      </ul>
    <div class="tab-content contractNameTab" id="pills-tabContent">
      <div className={`tab-pane fade ${showkeyrisk!=false ? 'show active' : ''}`} id="pills-contract_details" role="tabpanel" aria-labelledby="pills-contract_details-tab">
      <div className="container">
      <div className="sortDiv" id="sortDiv">
      <label>Sort</label>
      <select onChange={(e) => handleSort(e.target.value)} value={sortColumn}>
        <option value="Overall">Overall</option>
        <option value="TMS ID | Team Name">TMS ID | Team Name</option>
        <option value="Market | MU or IG | Industry">Market | MU or IG | Industry</option>  
        <option value="Delivery">Delivery</option>
        <option value="Financial">Financial</option>
        <option value="People / Resources">People/Resources</option>
        <option value="Information Security">Information Security</option>
        <option value="Contract Management">Contract Management</option>
      </select>
      </div>
      <div className="table-wrapper">
      <table className="table table-bordered smart-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col} className="position-relative">
                <div className="d-flex align-items-center justify-content-between">
                  {col}
                  {displayCol.includes(col) && (
                  <i className="bi bi-filter" style={{ width: "16px", height: "16px", cursor: "pointer" }} onClick={() => handleFilterClick(col)}></i>
                )}
                  </div>

                {modalOpen && filterColumn === col && (
                  <div
                    className="border p-2 bg-white shadow-sm position-absolute filter-popup"
                    style={{
                      top: "100%",
                      left: "0",
                      width: "250px",
                      zIndex: 1050,
                    }}
                  >
                    <div className="mb-2 fw-bold">{`Filter ${col}`}</div>
                    <div class="input-container">
                        <input
                          type="text"
                          className="form-control mb-2 input-underline"
                          placeholder="Search..."
                          value={searchText}
                          class="input-underline"
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                        <i class="bi bi-search search-icon"></i> 
                     </div>
                    <div className="form-check mb-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="selectAll"
                        checked={allSelected}
                        onChange={handleSelectAll}
                      />
                      <label className="form-check-label selectAllLabel" htmlFor="selectAll">
                        Select All
                      </label>
                    </div>
                    <hr/>
                    <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                      {getUniqueOptions().map((option, idx) => (
                        <div className="form-check" key={idx}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            class="selectAllInput"
                            id={`check-${option}`}
                            checked={!!selectedOptions[option]}
                            onChange={() => handleCheckboxChange(option)}
                          />
                          <label
                            className="form-check-label selectAllLabel"
                            htmlFor={`check-${option}`}
                          >
                            {option}
                          </label>
                        </div>
                      ))}
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-2">
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => setModalOpen(false)}
                      >
                        Close
                      </button>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={handleApply}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {filteredData.map((row, idx) => (
            <tr key={idx}  onClick={() => handleRowClick(row)}>
                {columns.map((col) => {
                    const cellValue = row[col];
                    const className = displayColumnsData(col,row[col]); // assuming "Green" or "green"
                    console.log('className',className);
                    const title = titleMap[cellValue] || '';
                    console.log('title',title);
                    
                    return (
                      <td key={col} className={cellValue} title={title}>
                        {className}
                      </td>
                    );
                  })}
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
        </div>
      <div className={`tab-pane fade ${showkeyrisk==false ? 'show active' : ''}`} id="pills-key_risks" role="tabpanel" aria-labelledby="pills-key_risks-tab">
        <h5 className='accentureColor'>Overall Summary</h5>
        <div>
        <ReactMarkdown>
          {contractDemographicsWeb && contractDemographicsWeb.contract_demographics_web && contractDemographicsWeb.contract_demographics_web['Overall Summary']?contractDemographicsWeb.contract_demographics_web['Overall Summary']:''}
        </ReactMarkdown>
        </div>
        <> {contractDemographicsWeb.contract_demographics_web?.['Focusjob_PJPPJ_Tagging']?.['Tagging'] && contractDemographicsWeb.contract_demographics_web?.['Focusjob_PJPPJ_Tagging']?.['Tagging']!=='None'
  && <>
  <h5 className="accentureColor">Reason for Tagging - {contractDemographicsWeb.contract_demographics_web?.['Focusjob_PJPPJ_Tagging']?.['Tagging'] ?? 'None'}</h5>

  <div>
    {(() => {
      const focusContext =
        contractDemographicsWeb.contract_demographics_web?.['focusjob_context'];
      const isFocusJob = focusContext?.[0]?.['focus_job'] === 'Yes';

      console.log("focusContext:", focusContext);
      console.log("isFocusJob:", isFocusJob);

if (isFocusJob && focusContext.length > 0) {
  console.log('contractDemographicsWeb',contractDemographicsWeb)
  let focusJobTagging =contractDemographicsWeb.contract_demographics_web['Focusjob_PJPPJ_Tagging']['Reason for Review Tagging'];
  let contributing_str=contractDemographicsWeb.contract_demographics_web['Focusjob_PJPPJ_Tagging']['Contributing Market/MU or IG'].join(',');
  focusJobTagging +='\n\n &nbsp; &nbsp; Contributing Market - MU/IG as per Focus Job: '+contributing_str +'\n\n'
  if(contractDemographicsWeb.contract_demographics_web['Focusjob_PJPPJ_Tagging']['filename'])
  focusJobTagging +="&nbsp; &nbsp; *Data Source: "+contractDemographicsWeb.contract_demographics_web['Focusjob_PJPPJ_Tagging']['filename']+"*\n"
  console.log('focusJobTagging',focusJobTagging,contributing_str);
  return <ReactMarkdown>{focusJobTagging}</ReactMarkdown>;
    // return (
    //   <div>
    //     <table className="table table-bordered table-sm mt-2">
    //       <thead className="table-light">
    //         <tr>
    //           <th>Contributing Market</th>
    //           <th>Contributing MU or IG</th>
    //           <th>Reason for Focus</th>
    //           <th>Status</th>
    //         </tr>
    //       </thead>
    //       <tbody>
    //         {focusContext.map((item, index) => (
    //           <tr key={index}>
    //             <td>{item["market_new"]}</td>
    //             <td>{item["market_unit_new"]}</td>
    //             <td>{item["reason_for_focus"]}</td>
    //             <td><ShowMoreText text={item["status"]} /></td>
    //           </tr>
    //         ))}
    //       </tbody>
    //     </table>
    //   </div>
    // );
  
}


      // Fallback when focus job is not 'Yes'
      const focusJobTagging =
        contractDemographicsWeb.contract_demographics_web?.['Focusjob_PJPPJ_Tagging']?.['Reason for Review Tagging'];

      if (focusJobTagging) {
        return <ReactMarkdown>{focusJobTagging}</ReactMarkdown>;
      }

      // Default case
      return <p>None</p>;
    })()}
  </div>
</>
       }
       </>
        <h5 className='accentureColor'>Overall Risk/Issue</h5>
        <div>
        <ReactMarkdown>
          {contractDemographicsWeb && contractDemographicsWeb.contract_demographics_web && contractDemographicsWeb.contract_demographics_web['Overall Risk/Issues1']?contractDemographicsWeb.contract_demographics_web['Overall Risk/Issues1'] :''}
        </ReactMarkdown>
        </div>
      </div>
      <div className="tab-pane fade" id="gen_ai_status" role="tabpanel" aria-labelledby="gen_ai_status-tab">
      <div className="container">
      {/* <div className="sortDiv" id="sortDiv">
      <label>Sort</label>
      <select onChange={(e) => handleGenAiSort(e.target.value)} value={genAISortColumn}>
         <option value="TMS ID | Team Name">TMS ID | Team Name</option>
       <option value="Market | MU or IG | Industry">Market | MU or IG | Industry</option>         
        <option value="Committed vs Scaled">Committed vs Scaled</option>
        <option value="Savings Reflection">Savings Reflection</option>
        <option value="GenAI Savings %">GenAI Savings %</option>
        <option value="Planned GenAI Productivity ($)">Planned GenAI Productivity ($)</option>
        <option value="Realized GenAI Productivity ($)">Realized GenAI Productivity ($)</option>
      </select>
      </div> */}
      {/* <div className="table-wrapper" id="table-wrapper">
      <table className="table table-bordered smart-table">
        <thead>
          <tr>
            {genAIcolumns.map((col) => (
              <th key={col} className="position-relative">
                <div className="d-flex align-items-center justify-content-between">
                  {col}
                  {genAIDisplayCol.includes(col) && (
                  <i className="bi bi-filter" style={{ width: "16px", height: "16px", cursor: "pointer" }} onClick={() => handleGenAIFilterClick(col)}></i>
                )}
                  </div>

                {genAIModalOpen && genAIFilterColumn === col && (
                  <div
                    className="border p-2 bg-white shadow-sm position-absolute filter-popup"
                    style={{
                      top: "100%",
                      left: "0",
                      width: "250px",
                      zIndex: 1050,
                    }}
                  >
                    <div className="mb-2 fw-bold">{`Filter ${col}`}</div>
                    <div class="input-container">
                        <input
                          type="text"
                          className="form-control mb-2 input-underline"
                          placeholder="Search..."
                          value={genAISearchText}
                          class="input-underline"
                          onChange={(e) => setGenAISearchText(e.target.value)}
                        />
                        <i class="bi bi-search search-icon"></i> 
                     </div>
                    <div className="form-check mb-2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="selectAll"
                        checked={genAIAllSelected}
                        onChange={handleGenAISelectAll}
                      />
                      <label className="form-check-label selectAllLabel" htmlFor="selectAll">
                        Select All
                      </label>
                    </div>
                    <hr/>
                    <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                      {getGenAIUniqueOptions().map((option, idx) => (
                        <div className="form-check" key={idx} >
                          <input
                            className="form-check-input"
                            type="checkbox"
                            class="selectAllInput"
                            id={`check-${option}`}
                            checked={!!selectedGenAIOptions[option]}
                            onChange={() => handleGenAICheckboxChange(option)}
                          />
                          <label
                            className="form-check-label selectAllLabel"
                            htmlFor={`check-${option}`}
                          >
                            {option}
                          </label>
                        </div>
                      ))}
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-2">
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => setGenAIModalOpen(false)}
                      >
                        Close
                      </button>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={handleGenAIApply}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {genAIFilteredData.map((row, idx) => (
            <tr key={idx} className='clienttr' onClick={() => handleRowClick(row)}>
                  {genAIcolumns.map((col) => {
                    const cellValue = row[col];
                    const className = displayGenAIColumnsData(col,row[col]); // assuming "Green" or "green"
                    console.log('className',className);
                    const title = titleMap[cellValue] || '';
                    console.log('title',title);
                    
                    return (
                      <td key={col} className={cellValue} title={title}>
                        {className}
                      </td>
                    );
                  })}
            </tr>           
          ))}
        </tbody>
      </table>
      </div> */}

    {(() => {
  // Validate projectDemographicsWeb existence
  if (
    !contractDemographicsWeb ||
    !contractDemographicsWeb.contract_demographics_web
  ) {
    return <p className="text-center mt-3 text-danger">No data available.</p>;
  }

  const isEmpty = (val) =>
  val === "" || val === null || val === undefined;

  
  const hasData = (type) =>
    contractDemographicsWeb.contract_demographics_web.tmsList.some(item => Array.isArray(item[type]) && item[type].length > 0);

  const safe = (v) =>
  v === null || v === undefined || String(v).toLowerCase() === "nan"
    ? "--"
    : v;
  const mergeDataByName = (data = []) => {
  if (!Array.isArray(data)) return [];

  return data.map(item => ({
    'TMS ID | Team Name': item['TMS ID | Team Name'],
    'Market | Market Unit | CSG': item['Market | Market Unit | CSG'],
    list: mergeListByServiceGroup(item['Gen AI'])
  }));
};

// const isListEmpty = (data = []) => {
//   if (!Array.isArray(data)) return false;

//   return data.some(item =>
//     !Array.isArray(item?.list) ||
//     item.list.every(row => !row || Object.keys(row).length === 0)
//   );
// };

const hasAnyNonEmptyList = (list) =>
  !Array.isArray(list) ||
  list.every(item =>
    !item ||
    (typeof item === "object" && Object.keys(item).length === 0)
  );
const isListEmpty = (data = []) =>
  Array.isArray(data) &&
  data.some(item => !hasAnyNonEmptyList(item.list));

  const mergeListByServiceGroup = (list = []) => {
  if (!Array.isArray(list)) return [];

  const map = {};

  list.forEach(item => {
    const key = item?.genaiappliedservicegroup;
    if (!key) return;

    if (!map[key]) {
      map[key] = { ...item };
    } else {
      Object.keys(item).forEach(field => {
        if (isEmpty(map[key][field]) && !isEmpty(item[field])) {
          map[key][field] = item[field];
        }
      });
    }
  });

  return Object.values(map);
};



 const renderRowspanTable = (data) => {
   // data = data || [];
  //   const VALID_FIELDS = ["genaiappliedservicegroup", "ragStatus", "pattern", "genaiappliedservicegroup", "genaiproductivity", "whereIsTheSavingsBeingReflected"];
  //   const hasValue = v =>
  // v !== null && v !== undefined && v !== "";

  //   const tableData = Array.isArray(data)
  // ? data.filter(row =>
  //     VALID_FIELDS.some(field => hasValue(row?.[field]))
  //   )
  // : [];
    const tableData=mergeDataByName(data)
    console.log('tableData',tableData);
    const genaiempty=isListEmpty(tableData)
    console.log('genaiempty',genaiempty);
    // if (!tableData.length) return <div className="text-muted">No Data Available</div>;

    return (
      <div className="container mt-3">
         <Table bordered hover striped size="sm" responsive>           
          <thead>
            <tr className='bg-white'><th></th><th colSpan='4'>Committed</th><th className='bg-white' colSpan='3'>Scaled</th></tr>
       </thead>

          <tbody>
             <tr>
              <th>TMS ID | Team Name</th>
              <th>Market | Market Unit | CSG</th>
              <th>Service Group</th>
              <th>Gen AI RAG</th>
              <th>Pattern</th>
              <th>Gen AI Effort Savings (%)</th>
              <th>Overall Productivity(%)</th>
              <th>Planned Gen AI Productivity ($)</th>
              <th>Realized Gen AI Productivity ($)</th>
              <th>Savings Reflection</th>
            </tr>
            {genaiempty ? (
tableData.map((item, index) => {
              const rows = item.list || [];
              const rowSpanCount = rows.length;

              return rows.map((ga, i) => (
                <tr key={`${index}-${i}`} onClick={() => handleRowClick(item)}>
                  {i === 0 && (
                    <td rowSpan={rowSpanCount} className="align-middle">
                      {item['TMS ID | Team Name']}
                    </td>
                  )}

                  {i === 0 && (
                    <td rowSpan={rowSpanCount} className="align-middle">
                      {item['Market | Market Unit | CSG']}
                    </td>
                  )}

                  <td>{safe(ga['genaiappliedservicegroup'])|| '--'}</td>
                  <td>{getRagIcon(ga['ragStatus'])}</td>
                  <td>{safe(ga['pattern']) || '--'}</td>
                  <td>{ga['genaiappliedservicegroup']=='SI'?safe(ga['effortsavingsgenaiplannedperc']):'--'}</td>
                  <td>{ga['genaiappliedservicegroup']!='SI'?safe(ga['effortsavingsgenaiplannedperc']):'--'}</td>
                  <td>{safe(ga['genaiproductivity']) || '--'}</td>
                  <td>{safe(ga['genairealizedproductivity']) || '--' }</td>
                  <td>{safe(ga['whereIsTheSavingsBeingReflected']) || '--' }</td>
                </tr> 
              ));
            })) : (
      <tr>
        <td colSpan="10" className="text-center">
          No data available
        </td>
      </tr>
    )}
          </tbody>
        </Table>
      </div>
    );
  };


  return (
    <div className="container mt-4">
      {/* Expand / Collapse ALL */}
      <div className="d-flex justify-content-between align-items-center w-100">

  <div className="mb-2">
      <ul className="mb-0">
          <li>Committed | Scaled : {contractDemographicsWeb.contract_demographics_web["Committed | Scaled"] || 'NA'}</li>
    </ul>
    {renderRowspanTable(contractDemographicsWeb.contract_demographics_web.tmsList)}
  </div>
</div>

                 <div className="d-flex justify-content-between align-items-center mt-2">
  <div>
    For more details, view the{" "}
    <a href={''}>for more details on the Gen AI status of this project</a>
  </div>
  <div>
    Source: <a href="">ATCI Delivery Portal</a>
  </div>
</div>
    </div>
  )


})()}
    </div>
        </div>
      {showFeedback && (<FeedbackWidget moduleName="contract_demographics_web" onSubmit={() => setShowFeedback(false)}/>)}
      <div className="footerText">Content Generated by Gen AI, limiting accuracy in few cases. Please use at your own discretion.</div>
    </div>
    {loading && <Loader />} 
    </Container>    
    </div>
  );
};

export default Contract;
